import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Header from './components/MainPanel/Header';

import routes from './routes';
import GetFooter from './containers/GetFooter';
import GetMenuFooter from './containers/GetMenuFooter';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null
    }
  }

  showContentMenus = routes => {
    let result = [];
    if (routes.length) {
      result = routes.map((route, index) => {
        return (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={route.main}
          />
        );
      });
    }
    return <Switch>{result}</Switch>;
  }

  render() {
    return (
      <Router>
        <div className="wrapper-100vh">
            <Fragment>
            <Header/>
            {this.showContentMenus(routes)}
            <GetMenuFooter />
            <GetFooter />
          </Fragment>
          </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js